import { render } from "./AuthenticateForm.vue?vue&type=template&id=7087582e"
import script from "./AuthenticateForm.vue?vue&type=script&lang=js"
export * from "./AuthenticateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__